// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeShortDescription_container__l8oJN","details":"RecipeShortDescription_details__aF2hz"};